<!--suppress ALL -->
<template>
  <l-layout :layout="[ 'xs12']" bottom-space>
    <l-data-table
      v-if="!loading"
      :filter-items="filterItems"
      :get-data-func="getLetterReservations_Manager"
      @click:row="getDetails($event.item)"
      :headers="letterReservationHeader"
      clickable
      init-sort-by="name"
      ref="letterReservationList"
      title-text="函件预约申请列表"
      hide-title-search
    >
      <!--      <template slot="title-action">
              <l-option-menu
                :options="moreActions"
                @delete="deleteUser(selected)"
              >
                <v-btn icon slot="activator">
                  <v-icon>$vuetify.icons.more</v-icon>
                </v-btn>
              </l-option-menu>
            </template>-->
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
<!--          <l-option-menu
            :options="moreActions"
            @review="reviewReservation(item)"
            @delete="deleteReservation(item)"
            @deepDelete="deepDeleteReservation(item)"
            @comment="getCommentList(item)"
          >
            <v-btn icon slot="activator">
              <v-icon>$vuetify.icons.more</v-icon>
            </v-btn>
          </l-option-menu>-->
          <v-menu  left>
            <v-btn slot="activator" icon small>
              <v-icon  small>$vuetify.icons.more</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="reviewReservation(item)" :disabled="(item.reviewStatus+''!=='2'&&item.reviewStatus+''!=='5')" v-if="item.reviewer==='null'">
                <v-list-tile-title class="pr-1">
                  审核申请
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteReservation(item)">
                <v-list-tile-title class="pr-1">
                  删除申请
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deepDeleteReservation(item)">
                <v-list-tile-title class="pr-1">
                  完全删除（开发人员使用）
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="getCommentList(item)">
                <v-list-tile-title class="pr-1">
                  查看附言
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </l-data-table>
    <v-dialog
      v-model="commentDialog"
      width="500">
      <v-layout column>
        <v-card>
          <v-card-title>
            <span>函件预约附言</span>
            <v-spacer></v-spacer>
            <!--<v-btn icon @click="commentDialog=false">
              <v-icon>close</v-icon>
            </v-btn>-->
          </v-card-title>
          <v-card-text class="pa-0">
            <div v-if="commentList.length===0">
              <v-divider></v-divider>
              <v-layout justify-center class="ma-2">
                <span class="error--text">暂无记录</span>
              </v-layout>
            </div>
            <div v-else>
              <v-layout column>
                <v-layout v-for="(item,index) in commentList"  :key="index" column>
                  <v-divider></v-divider>
                  <div style="text-align: left" v-if="index%2===0" class="pa-2">
                    <p>{{item.createdBy}}</p>
                   <!-- <p>{{time.stringify(item.createdTime)}}</p>-->
                    <p>{{item.content}}</p>
                  </div>
                  <div style="text-align: right" v-else class="pa-2">
                    <p>{{item.createdBy}}</p>
                   <!-- <p>{{time.stringify(item.createdTime)}}</p>-->
                    <p>{{item.content}}</p>
                  </div>
                </v-layout>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
    </v-layout>
  </l-layout>
</template>
<script>
  import {time} from '../../../ladmin/utils/time'
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '创建未提交';
      case '2':return '首次提交待审核';
      case '3':return '退回返修';
      case '4':return '返修更新未提交';
      case '5':return '返修提交待审核';
      case '6':return '审核通过';
      case '7':return '审核拒绝';
      default:return v;
    }
  }
  export default{
    name:'LetterReservationReview',
    data:()=>({
      letterReservationHeader:[
        {
          text:'审核状态',
          align:'left',
          value:'reviewStatus',
          placeholder:'N/A',
          f:v=>reviewStatusTrans(v)
        },
        {
          text:'活动名称',
          align:'left',
          value:'obGrpName',
          placeholder:'N/A'
        },
        {
          text:'申请者姓名',
          align:'left',
          value:'applName',
          placeholder:'N/A'
        },
        {
          text:'申请类型',
          align:'left',
          value:'rootProcInst',
          placeholder:'N/A',
          f:v=>(v===true)?'首次申请':'追加申请'
        },
        {
          text:'申请时间',
          align:'left',
          value:'obGrpCreateTime',
          placeholder:'N/A',
          f:v=>time.stringify(v)
        },
        {text: '', value: '', align: 'right', width: '80px', sortable: false}
      ],
      filterItems:[
        {
          prependIcon: '',
          key: 'reviewStatus',
          value: '',
          label: '查询类型',
          type: 'select',
          items:[{
            value:'0',
            text:'全部申请'
          },
            {
              value:'2',
              text:'提交审核'
            },
            {
              value:'3',
              text:'退回返修'
            },
            {
              value:'4',
              text:'审核通过'
            },
            {
              value:'5',
              text:'审核拒绝'
            }],
          itemValue:'value',
          itemText:'text',
          layout: ['xs12', 'sm4'],
        },
      ],
      loading:false,
      commentDialog:false,
      commentList:[],
      moreActions:[
        {
          event:'review',
          label:'审核申请',
          icon:''
        },
        {
          event:'delete',
          label:'删除申请',
          icon:''
        },
        {
          event:'deepDelete',
          label:'完全删除（开发人员使用）',
          icon:''
        },
        {
          event:'comment',
          label:'查看附言',
          icon:''
        }
      ]
    }),
    methods:{
      /*获取全部函件预约信息*/
      async getLetterReservations_Manager({pagination, sortStack, filterItems, search}){
        let res = await this.$store.dispatch('letterReservation/getLetterReservations_Manager',{
          pagination,sortStack,filter:filterItems[0].value,search
        });
        if(res.data.code+''==='200')
        {
          return {items:res.data.data.content,amount:res.data.data.totalSize}
        }
        else
        {
          this.$L.alert('error',{message:'查询函件预约数据失败'})
        }
      },
      /*获取已部署流程ID*/
      async getDeployedProcess(){
        this.loading=true;
        let res = await this.$store.dispatch('letterReservation/getDeployedProcess');
        this.loading=false;
        if(res.data.code+''==='200')
        {
          sessionStorage.setItem('processId',res.data.data[0].id);
        }
        else
        {
          this.$L.alert('error',{message:'查询部署流程失败'})
        }
      },
      /*获取到函件预约详细信息*/
      async getDetails(item){
        //console.log(item)
        let selectionString = document.getSelection().toString();
        if(!selectionString)
        {
          if(item.reviewStatus+''==='5'||item.reviewStatus+''==='2')
          {
            if(item.reviewer==='null'||item.reviewer===this.getUserInfo().id)
            {
                this.reviewReservation(item)
            }
            else
              this.readReservation(item)
          }
          else
          {
            //console.log(item);
            this.readReservation(item)
          }
        }
      },
      /*审核函件预约*/
      async reviewReservation(item){
        //console.log(item)
        if(item.reviewer==='null')
        {
          let {res,close} = await this.$L.confirm({title:'提示',text:'您确定要审核该预约？（点击确定后，其他人将无法审核该预约）'})
          if(res){
            this.$router.push({
              name:'reservationDetails',
              query:{id:item.id,status:'review',obGrpName:item.obGrpName}})
          }
          close()
        }else {
          this.$router.push({
            name:'reservationDetails',
            query:{id:item.id,status:'review',obGrpName:item.obGrpName}})
        }
/*        let config = {
          "assignee":this.getUserInfo().id,
          "procInstId":item.id,
          "groups":[
            "admin"
          ]
        }
        let res1 = await this.$store.dispatch('letterReservation/getReviewTask',config)
        if(res1.data.code+''==='200'){
          if(res1.data.data[0]!=undefined||res1.data.data[0]!=null){
            let config = {
              "taskIdList":[res1.data.data[0].taskId],
              "assignee":this.getUserInfo().id
            }
            let res2 = await this.$store.dispatch('letterReservation/signTask',config)
            if(res2.data.code+''==='200')
            {
              let taskConfig = res1.data.data[0];
              this.$router.push({
                name:'reservationDetails',
                params:{taskConfig:taskConfig,status:'review',obGrpName:item.obGrpName},
                query:{id:item.id}})
            }
            else
            {
              this.$L.alert('error',{message:'签收任务失败'})
            }
          }
          else
            this.$L.alert('error',{message:'未查询到任务'})
        }else{
          this.$L.alert('error',{message:'查询任务失败'})
        }*/
      },
      /*删除函件预约*/
      async deleteReservation(item){
        let {res,close} = await this.$L.confirm({title:'提示',text:'您确定要删除该函件预约？'})
        if(res){
          try {
            let res = await this.$store.dispatch('letterReservation/deleteReservation_manager',item.id)
            if(res.data.code+''==='200'){
              this.$L.alert('success',{message:'删除成功'})
              this.$refs.letterReservationList.refresh()
            }
          }catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      /*完全删除函件预约*/
      async deepDeleteReservation(item){
        let {res,close} = await this.$L.confirm({title:'提示',text:'您确定要删除该函件预约？'})
        if(res){
          try {
            let res = await this.$store.dispatch('letterReservation/deepDeleteReservation',item.id)
            if(res.data.code+''==='200'){
              this.$L.alert('success',{message:'删除成功'})
              this.$refs.letterReservationList.refresh()
            }
          }catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      /*获取函件预约附言列表*/
      async getCommentList(item){
        this.commentDialog=true
        let res = await this.$store.dispatch('letterReservation/getCommentList',item.id)
        if(res.data.code+''==='200'){
          console.log(res)
          if(res.data.data!=null)
            this.commentList=res.data.data;
        }else{
          this.$L.alert('error',{message:'查询附言失败，原因：'+res.data.msg})
        }
      },
      /*只读函件预约*/
      async readReservation(item){
        this.$router.push({
          name:'reservationDetails',
          query:{id:item.id,status:'read',obGrpName:item.obGrpName}})
      },
      /*获取用户信息*/
      getUserInfo(){
        let loginInfo = sessionStorage.getItem('loginInfo');
        loginInfo = eval('('+loginInfo+')');
        return loginInfo
      }
    },
    created(){
      this.getDeployedProcess();
    },
  }
</script>
